import { createSlice } from '@reduxjs/toolkit'
import { useCookies } from 'react-cookie'


export const loginSlice = createSlice({
  name: 'login',
  initialState: {
    username:'',
    password:'',
    recaptchaPassed: false,
    checkbox:false,
    loading:false,
    loginFeedback:{
        message: '',
        color: ''
      },
    phonenumber:'',
    usernameforotp:'',
    open:false,
    resetFeedback:{
      message: '',
      color: ''
    },
    openVerifyOTPModal:false,
    openModalResetByOTP:false,
    openModalResetByEmail:false,
    usernameReset: '',
    emailReset:'',
    otp:'',
    passwordReset:'',
    confirmpassword:'',
    loadingModalResetByOTP:false,
    loadingModalResetByEmail:false,
    timeLeft:20,
    value:null,
    showPassword:false

  },
  reducers: {
      setUsernameRedux: (state, action) => {
        const { username } = action.payload
        state.username = username
      },
      setPasswordRedux: (state, action) => {
        const { passwordReset } = action.payload
        state.passwordReset = passwordReset
      },
      setPasswordLoginRedux: (state, action) => {
        const { password } = action.payload
        state.password = password
      },
      setRecaptchaPassedRedux: (state, action) => {
        const { recaptchaPassed } = action.payload
        state.recaptchaPassed = recaptchaPassed
    },
    
      setCheckboxRedux: (state, action) => {
        const { checkbox } = action.payload
        state.checkbox = checkbox
      },
      setLoadingRedux: (state, action) => {
        const { loading } = action.payload
        state.loading = loading
      },
      setLoginFeedbackRedux: (state, action) => {
        const { loginFeedback } = action.payload
        state.loginFeedback = loginFeedback
      },
      setPhoneNumberRedux: (state, action) => {
        const { phonenumber } = action.payload
        state.phonenumber = phonenumber
      },
      setUsernameForOTPRedux: (state, action) => {
        const { usernameforotp } = action.payload
        state.usernameforotp = usernameforotp
      },
      setOpenRedux: (state, action) => {
        const { open } = action.payload
        state.open = open
      },
      setResetFeedbackRedux: (state, action) => {
        const { resetFeedback } = action.payload
        state.resetFeedback = resetFeedback
      },
      setOpenVerifyOTPModalRedux: (state, action) => {
        const { openVerifyOTPModal } = action.payload
        state.openVerifyOTPModal = openVerifyOTPModal
      },
      setOpenModalResetByOTPRedux: (state, action) => {
        const { openModalResetByOTP } = action.payload
        state.openModalResetByOTP = openModalResetByOTP
      },
      setOpenModalResetByEmailRedux: (state, action) => {
        const { openModalResetByEmail } = action.payload
        state.openModalResetByEmail = openModalResetByEmail
      },
      
      setEmailResetRedux: (state, action) => {
        const { emailReset } = action.payload
        state.emailReset = emailReset
      },
      setOtpRedux: (state, action) => {
        const { otp } = action.payload
        state.otp = otp
      },
      setPasswordResetRedux: (state, action) => {
        const { passwordReset } = action.payload
        state.passwordReset = passwordReset
      },
      setConfirmPasswordRedux: (state, action) => {
        const { confirmpassword } = action.payload
        state.confirmpassword = confirmpassword
      },
      setLoadingModalResetByOTPRedux: (state, action) => {
        const { loadingModalResetByOTP } = action.payload
        state.loadingModalResetByOTP = loadingModalResetByOTP
      },
      setLoadingModalResetByEmailRedux: (state, action) => {
        const { loadingModalResetByEmail } = action.payload
        state.loadingModalResetByEmail = loadingModalResetByEmail
      },
      setTimeLeftRedux: (state, action) => {
        const { timeLeft } = action.payload
        state.timeLeft = timeLeft
      },
      setValueRedux: (state, action) => {
        const { value } = action.payload
        state.value = value
      },
      setShowPasswordRedux: (state, action) => {
        const { showPassword } = action.payload
        state.showPassword = showPassword
      },
      setUsernameResetRedux: (state, action) => {
        const { usernameReset } = action.payload
        state.usernameReset = usernameReset
      },
  },
})

export default loginSlice.reducer;

export const {
    setUsernameRedux,
    setPasswordLoginRedux,
    setPasswordRedux,
    setUsernameResetRedux,
    setRecaptchaPassedRedux,
    setCheckboxRedux,
    setLoadingRedux,
    setLoginFeedbackRedux,
    setPhoneNumberRedux,
    setUsernameForOTPRedux,
    setOpenRedux,
    setResetFeedbackRedux,
    setOpenVerifyOTPModalRedux,
    setOpenModalResetByOTPRedux,
    setOpenModalResetByEmailRedux,
    setEmailResetRedux,
    setOtpRedux,
    setPasswordResetRedux,
    setConfirmPasswordRedux,
    setLoadingModalResetByOTPRedux,
    setLoadingModalResetByEmailRedux,
    setTimeLeftRedux,
    setValueRedux,
    setShowPasswordRedux

} = loginSlice.actions


export const getUsernameRedux = (state) => state.login.username
export const getPasswordRedux = (state) => state.login.password
export const getPasswordLoginRedux = (state) => state.login.password
export const getRecaptchaPassedRedux = (state) => state.login.recaptchaPassed
export const getCheckboxRedux = (state) => state.login.checkbox
export const getLoadingRedux = (state) => state.login.loading
export const getLoginFeedbackRedux = (state) => state.login.loginFeedback
export const getPhoneNumber = (state) => state.login.phonenumber
export const getUsernameForOTPRedux = (state) => state.login.usernameforotp
export const getOpenRedux = (state) => state.login.open
export const getResetFeedbackRedux = (state) => state.login.resetFeedback
export const getOpenVerifyOTPModalRedux = (state) => state.login.openVerifyOTPModal
export const getOpenModalResetByOTPRedux = (state) => state.login.openModalResetByOTP
export const getOpenModalResetByEmailRedux = (state) => state.login.openModalResetByEmail
export const getEmailResetRedux = (state) => state.login.emailReset
export const getOtpRedux = (state) => state.login.otp
export const getPasswordResetRedux = (state) => state.login.passwordReset
export const getConfirmPasswordRedux = (state) => state.login.confirmpassword
export const getLoadingModalResetByOTPRedux = (state) => state.login.loadingModalResetByOTP
export const getLoadingModalResetByEmailRedux = (state) => state.login.loadingModalResetByEmail
export const getTimeLeftRedux = (state) => state.login.timeLeft
export const getValueRedux = (state) => state.login.value
export const getShowPasswordRedux = (state) => state.login.showPassword
export const getUsernameResetRedux = (state) => state.login.usernameReset


















